import "./App.css";

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <h1>Términos y Condiciones</h1>

        <h6>
          Sherpa S.A.S. (en adelante “Sherpa”), es un proveedor de diversas
          soluciones para la gestión de negocios enfocados en transporte a
          través de un aplicativo móvil y plataforma web. Las presentes
          condiciones exponen los derechos y obligaciones de usted como usuario
          (en adelante “Usuario”), y de Sherpa como proveedor del servicio. Lea
          detenidamente los presentes Términos y Condiciones antes de acceder a
          cualquier servicio o producto ofrecido por Sherpa. Al acceder al
          aplicativo móvil así como cualquiera de los sitios relacionados y
          vinculados a Sherpa, el Usuario manifiesta que ha leído y aceptado las
          condiciones de uso. Si el Usuario no está de acuerdo con todos estos
          términos y condiciones, queda prohibido su utilización del aplicativo
          y debe interrumpir el uso de manera inmediata. Al aceptar estos
          Términos y Condiciones, el Usuario se está vinculado jurídicamente con
          los servicios que a través de la plataforma tecnológica presta Sherpa,
          toda vez que las mencionadas condiciones constituyen un documento con
          plena validez jurídica. Mantenemos otros términos y políticas que
          complementan estos Términos y Condiciones, como nuestra Política de
          Privacidad, que describe la recopilación y el uso de datos personales,
          los cuales rigen los servicios prestados a los Usuarios por las
          entidades de Sherpa.
        </h6>
        <h4>Descripción de los servicios</h4>
        <h6>
          1. Aplicativo móvil y plataforma web ‍ Sherpa funciona y ofrece sus
          servicios mediante un aplicativo móvil y plataforma web, ambas
          totalmente gratuitas y actualmente disponibles para dispositivos con
          sistema operativo Android y ordenador, respectivamente, que cuentan
          con una serie de funcionalidades que ayudan a los propietarios de
          Vehículos de transporte a mejorar la gestión de su negocio. A través
          del aplicativo y plataforma web, el Usuario puede añadir las
          transacciones (Ingresos, gastos,) incurridas por el negocio y éstas
          quedarán registradas. Esta funcionalidad le permite al Usuario poder
          ver, editar y eliminar de manera sencilla todos los movimientos del
          negocio. También existe una funcionalidad de gestión de servicios y
          clientes, por la cual los Usuarios pueden controlar el los servicios
          de los Clientes de su negocio. Adicionalmente, el aplicativo permite
          ver resúmenes diarios, semanales y mensuales, calculando el margen
          obtenido. Sherpa permite a los negocios disminuir y ahorrar tiempo en
          tareas de registro de transacciones y gestión de la caja, permitiendo
          que los trabajadores puedan dedicar más horas a aquellas actividades
          de mayor utilidad para aumentar la productividad del negocio. El
          objetivo de Sherpa es acelerar la competitividad de los pequeños
          negocios en Latinoamérica para hacer frente a un entorno económico
          adverso y que favorece a las grandes corporaciones. Para ello, la
          primera prioridad de Sherpa es ganarse la confianza de sus Usuarios al
          brindar unos estándares de calidad y seguridad muy elevados y de
          manera gratuita. Sherpa no es una solución para llevar a cabo la
          contabilidad formal de los negocios, y por tanto no compartirá
          proactivamente los datos introducidos en el aplicativo o plataforma
          web con autoridades tributarias. Para más información acerca del uso
          de los datos por parte de Sherpa, referirse a la Política de
          Privacidad.
        </h6>
        <h4> Condiciones de uso</h4>
        <h6>
          {" "}
          1. Aplicativo móvil y plataforma web ‍ No está permitido el uso a
          personas menores de 18 años. Se deberá proporcionar un nombre
          completo, un número de teléfono, y toda la información requerida por
          Sherpa en el proceso de creación de la cuenta. No está permitido
          copiar ni modificar las aplicaciones, ninguna parte de estas, ni
          nuestras marcas comerciales registradas. No se le permite intentar
          extraer el código fuente de las aplicaciones, y tampoco debe intentar
          traducir las aplicaciones a otros idiomas o hacer versiones derivadas.
          Las aplicaciones en sí, y todas las marcas comerciales registradas,
          derechos de autor, derechos de base de datos y otros derechos de
          propiedad intelectual relacionados con ella, pertenecen únicamente a
          Sherpa. Sherpa se reserva el derecho de tomar todas las acciones
          legales pertinentes para la protección de su propiedad intelectual,
          así como de limitar total o parcialmente el acceso a su aplicación y/o
          plataforma web a determinadas personas sin necesidad de presentar una
          justificación. Sherpa podrá transferir información a las autoridades
          competentes en caso de ser requerido. Capacidad: Los servicios
          descritos solo están disponibles para personas que tengan capacidad
          legal para contratar. Inscripción: Es obligatorio completar el
          formulario de inscripción en todos sus campos con datos válidos para
          poder utilizar el servicio de Sherpa. El futuro Usuario deberá
          completarlo con su información personal de manera verídica, exacta y
          precisa (en adelante “Datos Personales”) y asume el compromiso de
          actualizar los Datos Personales conforme resulte necesario. Los
          Usuarios garantizan y responden, en cualquier caso, sobre la
          veracidad, exactitud, vigencia y autenticidad de los Datos Personales
          ingresados. Entre los datos solicitados se encuentran, sin limitarse
          a: (i) nombre del negocio; (ii) teléfono de contacto, entre demás
          datos que puedan ser solicitados para la identificación
          correspondiente del Usuario. Sherpa se reserva el derecho de solicitar
          algún comprobante y/o dato adicional a efectos de corroborar los Datos
          Personales del Usuario, así como de suspender temporal o
          definitivamente a aquellos Usuarios cuyos datos no hayan podido ser
          confirmados. En estos casos de inhabilitación, se darán de baja todos
          los artículos publicados, así como las ofertas realizadas, sin que
          ello genere algún derecho de resarcimiento. Sherpa asume que el
          Usuario cuenta con todos los permisos de funcionamiento requeridos,
          conforme a la actividad o el objeto social que declara en su registro.
          Sherpa se reserva la facultad de limitar, total o parcialmente, el
          acceso a su plataforma por parte de los Usuarios o cualquier tercero,
          así como cancelar, suspender, bloquear o no permitir la compra de
          determinados productos por parte de los Usuarios. Se obliga a mantener
          indemne a Sherpa de cualquier reclamación judicial o extrajudicial que
          se presente en su contra, producto del uso indebido o ilegal de la
          plataforma, entre otros. El Usuario se compromete a notificar a Sherpa
          en forma inmediata y por medio idóneo, cualquier uso no autorizado de
          su cuenta, así como el ingreso por terceros no autorizados a la misma.
          en cualquier momento, cancelar, rechazar o suspender de manera
          temporal o definitiva la afiliación del Usuario y/o su Cuenta Sherpa,
          especialmente cuando detecte inconsistencias en la información
          recibida y recaudada y/o se evidencien acciones sospechosas que
          contraríen las políticas de Sherpa.
        </h6>
        <h4>
          {" "}
          Al usar el servicio y los productos descritos, el usuario acepta que:
        </h4>
        <h6>
          Sherpa se encuentra exento de cualquier perjuicio que pueda sufrir el
          Usuario o sus clientes con ocasión de las transacciones procesadas.
          Debe tomar las medidas idóneas de seguridad para el correcto
          almacenamiento de la información relativa a clientes y las
          transacciones respectivas y/o la Cuenta Sherpa. Debe mantener control
          sobre el acceso y la utilización del POS y abstenerse de permitir su
          manipulación por personal ajeno. El Usuario asumirá la responsabilidad
          por irregularidades que puedan cometer sus empleados o asociados por
          la operación irregular del POS. Le corresponde de manera exclusiva
          cumplir con los deberes tributarios, cambiarios y aduaneros derivados
          del desarrollo de su negocio cuyos pagos sean procesados a través del
          POS y el sistema de pagos habilitado por Sherpa. No podrá utilizar el
          POS ni el sistema habilitado por Sherpa para facilitar, ocultar,
          manejar, invertir o aprovechar de cualquier forma activos provenientes
          de actividades ilícitas, o para dar apariencia de legalidad a
          actividades ilícitas y/o a activos vinculados con las misma. Deberá
          permitir la exhibición de calcomanías y demás material publicitario
          que identifique su afiliación con Sherpa. Sherpa se exime del retardo
          en el procesamiento en razón a horarios o procesos bancarios, o de
          fallas en el servicio de los demás agentes que intervienen o inciden
          en el procesamiento de pagos.
        </h6>
        <h4>Uso de su dispositivo</h4>
        <h6>
          El aplicativo y plataforma web de Sherpa almacena y procesa los datos
          personales que los usuarios proporcionan con el objetivo de poder
          proporcionar sus servicios adecuadamente. Es responsabilidad del
          usuario mantener su celular y/u ordenador con acceso seguro a la
          aplicación. Por lo tanto, le recomendamos no eliminar cualquier tipo
          de restricciones y limitaciones de software impuestas por el sistema
          operativo oficial de su dispositivo (“jailbreak”). Podría hacer que su
          teléfono u ordenador sea vulnerable a programas maliciosos,
          comprometer las características de seguridad de estos, y podría
          significar que la aplicación y/o plataforma web Sherpa no funcionará
          correctamente o no funcionará en absoluto. Ciertas funcionalidades de
          Sherpa pueden requerir de una conexión a internet activa por parte del
          dispositivo u ordenador. La conexión puede ser WiFi o proporcionada
          por su proveedor de red móvil, pero Sherpa no asume la responsabilidad
          de que el aplicativo no funcione con plena funcionalidad al no tener
          acceso a internet. Si el usuario está utilizando la aplicación fuera
          de un área con WiFi, debe recordar que sus términos del acuerdo con su
          proveedor de red móvil aún se aplicarán. Como resultado, es posible
          que su proveedor de servicios móviles le cobre el costo de los datos
          durante la conexión mientras accede a la aplicación u otros cargos de
          terceros. Al usar el aplicativo, el usuario acepta la responsabilidad
          de dichos cargos, incluidos los cargos por datos de roaming si usa la
          aplicación fuera de su territorio local (es decir, región o país) sin
          desactivar el roaming de datos. Si no es el pagador de facturas del
          dispositivo en el que está utilizando el aplicativo, Sherpa asume que
          el usuario ha recibido el permiso del pagador de facturas para usar el
          aplicativo. El usuario tiene la responsabilidad de mantener su
          dispositivo cargado para poder aprovechar el servicio. Sherpa no se
          responsabiliza del consumo de energía que se pueda ocasionar a raíz
          del uso del aplicativo. El usuario es responsable de mantener la
          privacidad de su cuenta. Sherpa no se hará responsable de cualquier
          daño o pérdida que pueda ser consecuencia de un error del usuario al
          proteger su información de acceso.
        </h6>
        <h4>Derechos de Autor y Propiedad Intelectual</h4>
        <h6>
          Todos los textos, gráficas, diseños, interfaces de Usuario,
          publicidad, imágenes, íconos, logos, software, bases de datos puestos
          a disposición del público y cualquier otro material (al cual en
          adelante se hará referencia como “Contenido”), tanto del sitio web
          como de la aplicación son de propiedad exclusiva de Sherpa S.A.S. Todo
          el Contenido que hace parte de la página web y de la aplicación se
          encuentran protegidos por normas de Derechos de Autor y por todas las
          normas nacionales e internacionales que le sean aplicables. El
          Contenido no puede ser copiado, reproducido, posteado, transmitido,
          republicado, trasladado o distribuido de ninguna manera a otro
          computador, servidor, o cualquier otro medio sin autorización por
          escrito de Sherpa S.A.S., el uso no autorizado del Contenido puede
          constituir una violación de las leyes colombianas y/o internacionales
          de Propiedad Intelectual. Ningún Usuario podrá vender o modificar el
          Contenido de manera alguna, ni ejecutar o anunciar públicamente el
          mismo, ni distribuirlo para propósitos distintos a los establecidos en
          estos Términos y Condiciones. Queda prohibido hacer web scraping en la
          plataforma de Sherpa y demás productos asociados.
        </h6>
        <h4>Incumplimiento a Obligaciones y Deberes del Usuario</h4>
        <h6>
          En el evento en el que el Usuario cometa directa o indirectamente
          algún tipo de fraude o irregularidad por medio de la plataforma y/o
          servicios de Sherpa, esta se reserva las acciones necesarias para
          impedir la comisión de dichas conductas. Esto incluye pero no se
          limita a restringir el acceso a servicios y/o productos específicos,
          así como el bloqueo de acceso a la aplicación de Sherpa, o incluso la
          cancelación de la cuenta del Usuario. Sherpa podrá a su libre
          discreción tomar cualquier medida que estime necesaria para la
          prevención y mitigación del Fraude en su Plataforma. Salvo solicitud
          de alguna autoridad competente, Sherpa no deberá compartir y/o
          publicar con sus Usuarios y/o terceros las medidas y políticas
          internas empleadas para prevenir el fraude y las irregularidades en su
          Plataforma. Esto, toda vez que el conocimiento de terceros sobre la
          infraestructura utilizada por Sherpa para el asunto podría perpetrar
          aún más la comisión de fraudes e irregularidades, pues les
          proporcionaría una suerte de manual para eludir los signos de alarma
          con los que cuenta la compañía.
        </h6>
        <h4>Contenido generado por el usuario</h4>
        <h6>
          El Usuario será capaz de generar contenido en la aplicación de Sherpa.
          Se entiende como contenido la información e imágenes introducidas, así
          como gráficos, reportes y otros materiales generados por Sherpa a
          través de información aportada. Al introducir contenido en el
          aplicativo, el Usuario mantiene la propiedad, derechos y autoridad
          sobre dicho contenido. A su vez, al introducir o generar contenido, el
          Usuario da permiso a Sherpa para el uso de dicho contenido con ámbito
          universal, de manera irrevocable, y de manera gratuita. Sherpa tratará
          el contenido de acuerdo con la Política de Privacidad.
        </h6>
        <h4>Terceras partes</h4>
        <h6>
          Sherpa puede tener relaciones con terceros para poder proveer el
          servicio con normalidad. Sherpa no se hará responsable por cualquier
          pérdida, directa o indirecta, experimentada por el Usuario cuando la
          raíz causante de dicha pérdida es una tercera parte involucrada en las
          funcionalidades de la aplicación. Algunos de los proveedores de
          servicios de terceros que utiliza Sherpa son: Google Ads Google Play
          Services Google Analytics for Firebase
        </h6>
        <h4>Datos del usuario final</h4>
        <h6>
          Si usted es un Usuario final, cuando utiliza nuestra aplicación y/o
          plataforma web, una integración o una aplicación del desarrollador,
          podemos recopilar sus datos de contacto entre otros del Usuario final.
          Usted es el único responsable de sus datos de contacto y del Usuario
          final. Por la presente, usted declara y garantiza que es el
          propietario de sus Datos de contacto y de Usuario final y que
          proporcionarnos estos para usarlos y divulgarlos de acuerdo con
          nuestra Política de privacidad no viola ningún derecho de terceros,
          incluidos los derechos de privacidad o cualquier ley, reglamento u
          obligación impuesta por un tercero. No estamos obligados a realizar
          una copia de seguridad de sus Datos de contacto ni de los Datos de
          contacto del Usuario final, pues estos pueden eliminarse en cualquier
          momento. Usted es el único responsable de crear copias de seguridad de
          sus Datos de contacto del Usuario final si lo desea. Adicionalmente,
          le pedimos permiso para acceder a su lista de contactos de su teléfono
          para ofrecerles servicios de identificación de ventas, gastos y deudas
          por contacto.
        </h6>
        <h4>Cambios en los servicios</h4>
        <h6>
          Sherpa se reserva el derecho de realizar actualizaciones del
          aplicativo, sin preaviso ni límite. El aplicativo está actualmente
          disponible para dispositivos con sistema operativo Android y
          ordenadores desde una plataforma web: los requisitos para el sistema
          operativo pueden cambiar, y deberá descargar las actualizaciones si
          desea seguir utilizando el servicio. Sherpa no se compromete que
          siempre actualizará la aplicación para que sea relevante para el
          Usuario y / o funcione con la versión de Android que haya instalado en
          su dispositivo. Sin embargo, el Usuario promete aceptar siempre las
          actualizaciones de la aplicación cuando se le ofrezca. Sherpa se
          reserva el derecho de dejar de proporcionar parte o la totalidad de
          sus servicios en cualquier momento sin notificarle la finalización.
        </h6>
        <h4>Costo de los servicios</h4>
        <h6>
          Todas las soluciones actualmente proporcionadas por Sherpa son
          gratuitas para todos los Usuarios. Sherpa se compromete a garantizar
          que la aplicación sea lo más útil y eficiente posible. Por esa razón,
          nos reservamos el derecho de realizar cambios en la aplicación o
          cobrar por algunos de los servicios, en cualquier momento y por
          cualquier motivo. Nunca le cobraríamos por servicios sin establecer de
          manera muy transparente el concepto y condiciones del cobro.
        </h6>
        <h4>Cancelación</h4>
        <h6>
          El Usuario es responsable de la correcta cancelación de su cuenta. El
          Usuario puede cancelar su cuenta en cualquier momento a través del
          aplicativo. Una vez cancelada, todo contenido del Usuario se eliminará
          en un periodo de 30 días.
        </h6>
        <h4>Modificaciones</h4>
        <h6>
          Sherpa podrá modificar los Términos y Condiciones en cualquier momento
          haciendo públicos en el Sitio los términos modificados. Todos los
          términos modificados entrarán en vigor el día de su publicación. Todo
          Usuario que no esté de acuerdo con las modificaciones efectuadas por
          Sherpa podrá solicitar la baja de la cuenta. El uso del sitio y/o
          servicios implica la aceptación de estos Términos y Condiciones de
          Sherpa.
        </h6>
        <h4>Contacto</h4>
        <h6>
          Si tiene alguna pregunta o sugerencia sobre nuestros Términos y
          Condiciones, no dude en ponerse en contacto con nosotros a través de
          transportesherpa@gmail.com o nuestro número de WhatsApp +57(320) 391
          8545.
        </h6>
      </header>
    </div>
  );
}

export default App;
